/**
 * Fix delivery summary bar positioning
 * Ensures delivery bar is NOT sticky while header IS sticky
 */

(function() {
  'use strict';

  function fixDeliveryBarPosition() {
    const deliveryBar = document.querySelector('.delivery-summary-header');
    const sectionHeader = document.querySelector('.section-header');
    
    if (deliveryBar) {
      if (sectionHeader && sectionHeader.contains(deliveryBar)) {
        sectionHeader.parentElement.insertBefore(deliveryBar, sectionHeader.nextSibling);
      }
      
      deliveryBar.style.setProperty('position', 'relative', 'important');
      deliveryBar.style.setProperty('z-index', '1', 'important');
      
      const innerBar = deliveryBar.querySelector('.delivery-summary-bar');
      if (innerBar) {
        innerBar.style.setProperty('position', 'static', 'important');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDeliveryBarPosition);
  } else {
    fixDeliveryBarPosition();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.classList && node.classList.contains('delivery-summary-header')) {
            setTimeout(fixDeliveryBarPosition, 100);
            break;
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
